import React, { useState } from 'react';
import { Building, Check, Pencil } from 'lucide-react';
import { setOrganizationSampleCode } from './api';
import { TubeState, labError } from './LaboratoryParts';
import { tx } from './i18n';
import './organizations.css';

function TubeCode({ organization, tube, mayRecord, onSaved }) {
  const [editing, setEditing] = useState(false), [code, setCode] = useState(tube.organizationCode || '');
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  // Their code can change until the lab receives the tube; a first code can still be recorded after.
  const editable = mayRecord && (tube.receivedAt === null || tube.organizationCode === null);
  async function save(event) {
    event.preventDefault();
    setBusy(true); setError('');
    try { await setOrganizationSampleCode(organization.id, tube.code, code); setEditing(false); await onSaved(); }
    catch (caught) { setError(labError(caught)); }
    finally { setBusy(false); }
  }
  return <li>
    <code>{tube.printedCode ?? tube.code}</code>
    <TubeState value={tube.acceptanceState} />
    {editing ? <form onSubmit={save} className="xo-org-code-form">
      <input value={code} onChange={event => setCode(event.target.value)} maxLength={64} disabled={busy} autoFocus aria-label={tx('ui.org.their_code_for', { code: tube.printedCode ?? tube.code })} />
      <button type="submit" className="xo-btn" disabled={busy || code.trim() === ''}><Check aria-hidden="true" />{tx('ui.org.save')}</button>
      <button type="button" className="xo-btn-2" onClick={() => setEditing(false)} disabled={busy}>{tx('ui.org.cancel')}</button>
    </form> : <span className="xo-org-their-code">{tube.organizationCode ? tx('ui.org.their_code', { code: tube.organizationCode }) : tx('ui.org.no_code')}
      {editable && <button type="button" className="xo-link" onClick={() => setEditing(true)}><Pencil aria-hidden="true" />{tx(tube.organizationCode ? 'ui.org.replace_code' : 'ui.org.record_code')}</button>}</span>}
    {error !== '' && <p className="xo-alert t-bad" role="alert">{error}</p>}
  </li>;
}

// Each tube of a sample with its acceptance state and the organization's own code.
export default function SampleOrganizationCodes({ organization, tubes, mayRecord, onSaved }) {
  if (tubes.length === 0) return null;
  return <section className="xo-sample-org-codes">
    <header><h3>{tx('ui.org.tubes')}</h3>{organization && <span><Building aria-hidden="true" />{organization.name}<small>{organization.code}</small></span>}</header>
    <ul>{tubes.map(tube => organization ? <TubeCode key={tube.uuid} organization={organization} tube={tube} mayRecord={mayRecord} onSaved={onSaved} />
      : <li key={tube.uuid}><code>{tube.printedCode ?? tube.code}</code><TubeState value={tube.acceptanceState} /></li>)}</ul>
  </section>;
}
